import React from 'react'
import { Button, Grid, Icon } from 'gu-ui-kit'
import styles from 'modules/Services/Network/subcomponents/AccountsList/account-list.module.scss'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { ROUTES } from 'constants/routes'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { StatusBadge } from 'modules/Services/Network/subcomponents/AccountsList/subcomponents/StatusBadge'

export const AutoReplenishButton = ({
  action,
  i18n,
  networkType,
  id,
  auto_replenishment,
  fullWidth = false,
  noLabel = false,
  ...rest
}) => {
  const pathGen = useGeneratePathI18n()
  const { t } = useTranslation()

  return !auto_replenishment?.is_available ? null : (
    <Grid
      wrap={false}
      alignItems={'center'}
      justifyContent={'between'}
      gap={8}
    >
      <Button
        component={Link}
        size={'s'}
        variant={'ghost'}
        link
        startIcon={
          <Icon
            name={'time-money'}
            color={rest.iconColor ?? 'inherit'}
          />
        }
        to={pathGen(ROUTES.AUTOREPLENISH, {
          i18n,
          networkType,
          accountId: id,
        })}
        additionalIcon={
          noLabel &&
          auto_replenishment?.is_enabled && (
            <Icon
              className={styles['accounts-list__action-link__additional-icon']}
              name={'status done'}
              color={'Accent-Confirm-Primary'}
              size={'s'}
            />
          )
        }
        {...rest}
        noLabel={noLabel}
      >
        {t(`services::account_list.extra_actions.${action}`)}
      </Button>
      {noLabel ? null : fullWidth ? (
        <StatusBadge
          status={
            auto_replenishment?.is_enabled
              ? 'auto_replenishment_enabled_short'
              : 'auto_replenishment_disabled_short'
          }
          className={styles['accounts-list__account-status']}
        />
      ) : (
        auto_replenishment?.is_enabled && (
          <Icon
            name={'status done'}
            color={'Accent-Confirm-Primary'}
          />
        )
      )}
    </Grid>
  )
}

AutoReplenishButton.propTypes = {
  action: PropTypes.string,
  id: PropTypes.number,
  type: PropTypes.string,
  i18n: PropTypes.string,
  networkType: PropTypes.string,
  auto_replenishment: PropTypes.object,
  noLabel: PropTypes.bool,
  fullWidth: PropTypes.bool,
}
